import type { ConsentCookieOptions } from './constants'

export function serializeSetCookie(
  name: string,
  value: string,
  options: Omit<ConsentCookieOptions, 'cookieNames'> = {},
) {
  const parts = [`${name}=${encodeURIComponent(value)}`]
  if (options.domain) parts.push(`Domain=${options.domain}`)
  if (options.path) parts.push(`Path=${options.path}`)
  if (options.maxAge != null) parts.push(`Max-Age=${options.maxAge}`)
  if (options.secure) parts.push('Secure')
  if (options.sameSite) parts.push(`SameSite=${options.sameSite}`)
  return parts.join('; ')
}

export function serializeDeleteCookie(
  name: string,
  options: Omit<ConsentCookieOptions, 'cookieNames' | 'maxAge'> = {},
) {
  return serializeSetCookie(name, '', { ...options, maxAge: 0 })
}

export function serializeBooleanCookie(
  name: string,
  value: boolean,
  options: Omit<ConsentCookieOptions, 'cookieNames'> = {},
) {
  return value
    ? serializeSetCookie(name, 'true', options)
    : serializeDeleteCookie(name, options)
}
